import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RoofingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"roofing"}/>
}
